/* eslint-disable react-hooks/exhaustive-deps */
import {
  ChevronDown,
  ChevronUp,
  Download,
  History,
  FileText
} from 'lucide-react'
import { useEffect, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Row,
  Table
} from 'react-bootstrap'
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom'
import Swal from 'sweetalert2'

import Loading from '../../../components/atoms/Loading'
import { BadgeStatusPrLists } from '../../../components/atoms/StatusLabel'
import ModalPrDetailTimeline from '../../../components/modal/ReceiveAtWarehouse/PrDetailTimeline'
import api from '../../../config/AxiosInstance'
import toast, { Toaster } from 'react-hot-toast'
import { convertDateWithTime } from '../../../helpers/constants'
import * as Common from '../../../utils/Common'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '18px',
  fontWeight: '600'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const cardFilterStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#333333',
  textTransform: 'uppercase',
  marginBottom: '0.5rem',
  letterSpacing: '0.5px'
}

function MaterialRejectDetailPage() {
  const { id } = useParams()
  const { state } = useLocation()
  const navigate = useNavigate()
  const [itemCoaCollapse, setItemCoaCollapse] = useState(true)
  const [data, setData] = useState({
    id: null,
    code: null,
    erp_doc: null,
    series_number: null,
    wms_dc_no: null,
    target_warehouse: null,
    vehicle: null,
    driver: null,
    status: null,
    items: [],
    stagings: [],
    receipt_details: [],
    created_by: null,
    created_at: null,
    updated_by: null,
    updated_at: null
  })
  const [showModalTimeline, setShowModalTimeline] = useState(false)
  const [prTimelineId, setPrTimelineId] = useState(null)
  const [loading, setLoading] = useState({
    page: false,
    download: {}
  })

  const columnItemCOA = [
    { key: 'sequence', label: 'No' },
    {
      key: 'item_code_name',
      label: 'Item Code - Name',
      component: (item) => `${item.item_code} - ${item.item_name}`
    },
    { key: 'batch', label: 'Batch' },
    {
      key: 'total_qty',
      label: 'Base Qty UOM',
      className: 'text-end',
      component: (item) =>
        item.total_qty ? `${Number(item.total_qty)} ${item.uom}` : '-'
    },
    {
      key: 'total_pack',
      label: 'Qty Kemasan',
      className: 'text-end',
      component: (item) =>
        item.total_pack ? `${item.total_pack} ${item.uom_pack}` : '-'
    },
    {
      key: 'destination_area',
      label: 'Destination Area',
      className: 'text-end'
    },
    {
      key: 'remark',
      label: 'Remark',
      className: 'text-end',
      component: (item) => (item.remark ? item.remark : '-')
    }
  ]

  const columnStagingArea = [
    {
      key: 'palet_id',
      label: 'Palet',
      component: (item) => `#${item.palet_id}`
    },
    {
      key: 'item_code_name',
      label: 'Item Code - Name',
      component: (item) => `${item.item_code} - ${item.item_name}`
    },
    { key: 'batch', label: 'Batch' },
    {
      key: 'total_pack',
      label: 'Receiving',
      className: 'text-end',
      component: (item) => `${item.total_pack} ${item.uom_pack}`
    },
    { key: 'location', label: 'Location', className: 'text-end' },
    {
      key: 'dest_area',
      label: 'Destination Area',
      className: 'text-end',
      component: (item) => item.dest_area || '-'
    },
    {
      key: 'action',
      label: 'Label',
      className: 'text-end',
      component: (item) => (
        <div key={item.id} className="d-flex justify-content-end">
          <Button
            type="button"
            variant={loading.download[item.id] ? 'secondary' : 'warning'}
            className={`${
              !loading.download[item.id] ? 'text-light' : 'opacity-25'
            }`}
          >
            <Download size={14} />
          </Button>
        </div>
      )
    }
  ]

  const columnItemReceipts = [
    {
      key: 'item_code_name',
      label: 'Item Code - Name',
      component: (item) => `${item.item_code} - ${item.item_name}`
    },
    { key: 'batch', label: 'Batch' },
    {
      key: 'total_pack',
      label: 'Quarantine Pack',
      className: 'text-end',
      component: (item) =>
        ![0, null, undefined].includes(item.total_pack)
          ? `${item.total_pack} ${item.uom_pack}`
          : 0
    },
    {
      key: 'total_qty',
      label: 'Quarantine Qty',
      className: 'text-end',
      component: (item) =>
        ![0, null, undefined].includes(item.total_qty)
          ? `${item.total_qty} ${item.uom}`
          : 0
    },
    {
      key: 'total_reject',
      label: 'Rejected Qty',
      className: 'text-end',
      component: (item) =>
        ![0, null, undefined].includes(item.total_reject)
          ? `${item.total_reject} ${item.uom_reject}`
          : 0
    }
  ]

  const handleModalTimeline = () => {
    const show = !showModalTimeline
    setShowModalTimeline(show)
    if (!show) {
      setPrTimelineId(null)
    }
  }

  const fetchDetail = async () => {
    try {
      setLoading((prev) => ({
        ...prev,
        page: true
      }))
      const res = await api.get(`/inbound/material-reject/detail/${id}`)
      const { data } = res
      if (data.success) {
        const { data: dataResponse } = data
        setData({
          ...dataResponse,
          stagings:
            dataResponse?.stagings?.map((staging) => ({
              ...staging,
              status:
                staging?.status === 'request_pnp'
                  ? 'waiting_om'
                  : staging?.status
            })) || [],
          status:
            dataResponse?.status === 'request_pnp'
              ? 'waiting_om'
              : dataResponse?.status
        })
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message ||
        error?.message ||
        'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
      navigate('/inbound/material-reject', { state: { state } })
    } finally {
      setLoading((prev) => ({
        ...prev,
        page: false
      }))
    }
  }

  const handleSubmitAndSendErp = () => {
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-primary-orange',
        cancelButton: 'btn btn-transparent',
        actions:
          'd-flex w-100 justify-content-end pt-4 ps-4 pe-4 separator-border-action-sweetalert'
      },
      buttonsStyling: false
    })
    swalWithBootstrapButtons
      .fire({
        title: 'Send to ERP?',
        text: 'This action can’t be repeated!',
        icon: 'warning',
        iconColor: '#828282',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Send',
        cancelButtonText: 'Cancel',
        allowOutsideClick: false,
        reverseButtons: true,
        showCloseButton: true
      })
      .then(async (result) => {
        if (result.isConfirmed) {
          try {
            const res = await api.post(
              `/inbound/material-reject/${data?.id}/send-erp`
            )
            if (res.data.success) {
              Swal.close()
              fetchDetail()
              toast.success('Success', {
                position: 'top-right',
                style: {
                  fontSize: '14px',
                  fontWeight: '600'
                }
              })
            }
          } catch (err) {
            Swal.close()
            const errMsg =
              err?.response?.data?.errors?.message || 'An error occurred'
            const swalWithBootstrapButtonError = Swal.mixin({
              customClass: {
                confirmButton: 'btn btn-primary-orange',
                cancelButton: 'btn btn-transparent',
                actions:
                  'd-flex w-100 justify-content-end pt-4 ps-4 pe-4 separator-border-action-sweetalert'
              },
              buttonsStyling: false
            })
            swalWithBootstrapButtonError
              .fire({
                html: `<p>Send to ERP <span class='text-danger fw-bold text-uppercase'>failed</span></p><br><p>Reason: ${errMsg}</p>`,
                icon: 'error',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                confirmButtonText: 'Resend',
                allowOutsideClick: false,
                showCloseButton: true
              })
              .then(async (result) => {
                if (result.isConfirmed) {
                  try {
                    const res = await api.post(
                      `inbound/ml-draft/${data?.id}/assign-area`
                    )
                    if (res.data.success) {
                      Swal.close()
                      fetchDetail()
                      toast.success('Success', {
                        position: 'top-right',
                        style: {
                          fontSize: '14px',
                          fontWeight: '600'
                        }
                      })
                    }
                  } catch (err) {
                    Swal.close()
                    const errMsg =
                      err?.response?.data?.errors?.message ||
                      'An error occurred'
                    Common.showPopUpErrorMessage(errMsg)
                  }
                }
              })
          }
        } else {
          return false
        }
      })
  }

  useEffect(() => {
    if (id) {
      fetchDetail()
    }
  }, [id])

  if (loading.page) {
    return <Loading />
  }

  const renderInfoItem = (label, value, col = 3) => (
    <Col md={col} className="mb-3">
      <small style={labelStyle}>{label}</small>
      <h5
        className="mt-1"
        style={{ fontSize: '1.05rem', wordBreak: 'break-word' }}
      >
        {value || '-'}
      </h5>
    </Col>
  )

  return (
    <>
      <Toaster />
      <Container fluid className="px-4 mb-5">
        <Row className="mb-4">
          <Col md={12}>
            <div className="d-flex flex-column justify-content-start">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb mb-1" style={{ fontSize: '12px' }}>
                  <li className="breadcrumb-item sj-item">
                    <Link
                      to="/inbound/material-reject"
                      state={state}
                      className="text-decoration-none"
                    >
                      <span className="text-muted fw-bold text-uppercase">
                        MR LIST
                      </span>
                    </Link>
                  </li>
                  <li
                    className="breadcrumb-item sj-item active"
                    aria-current="page"
                  >
                    <span className="fw-bold" style={{ color: '#bdbdbd' }}>
                      {data?.code || ''}
                    </span>
                  </li>
                </ol>
              </nav>
              <h4 style={headerTitleStyle}>
                {data?.code}{' '}
                <sup style={{ fontSize: '10px', verticalAlign: 'middle' }}>
                  <BadgeStatusPrLists
                    text={
                      data?.status ? data?.status.replaceAll('_', ' ') : 'done'
                    }
                  />
                </sup>
              </h4>
            </div>
          </Col>
        </Row>

        <Card style={cardFilterStyle}>
          <Row>
            {renderInfoItem('Series', data?.series_number, 4)}
            {renderInfoItem('Source Warehouse', data?.src_warehouse, 4)}
            {renderInfoItem('Target Warehouse', data?.target_warehouse, 4)}
            {renderInfoItem('WMS DC', data?.wms_dc_no, 3)}
            {renderInfoItem('Driver', data?.vehicle, 2)}
            {renderInfoItem('Car', data?.driver, 2)}
            {renderInfoItem('#ERP DOC NO', data?.erp_doc, 2)}
          </Row>
        </Card>

        <Card style={cardFilterStyle}>
          <div className="d-flex flex-row justify-content-between mb-3 align-items-center">
            <h5 className="fw-bold text-uppercase" style={{ color: '#828282' }}>
              Item
            </h5>
            <Button variant="transparent" className="p-0">
              {itemCoaCollapse ? (
                <ChevronUp
                  size={16}
                  onClick={() => setItemCoaCollapse(!itemCoaCollapse)}
                  style={{ cursor: 'pointer', color: '#828282' }}
                />
              ) : (
                <ChevronDown
                  size={16}
                  onClick={() => setItemCoaCollapse(!itemCoaCollapse)}
                  style={{ cursor: 'pointer', color: '#828282' }}
                />
              )}
            </Button>
          </div>
          <Collapse in={itemCoaCollapse}>
            <div>
              <Table
                hover
                responsive
                className="shadow-sm bg-white"
                style={{
                  fontSize: '13px',
                  borderRadius: '12px',
                  overflow: 'hidden',
                  marginBottom: 0
                }}
              >
                <thead style={{ backgroundColor: '#f8f9fa' }}>
                  <tr>
                    {columnItemCOA.map((column) => (
                      <th
                        className={`p-2 align-middle ${column.className}`}
                        key={column.key}
                        style={tableHeaderStyle}
                      >
                        {column.label}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {data?.items?.length === 0 && (
                    <tr>
                      <td colSpan={columnItemCOA.length} className="p-3">
                        <div className="d-flex justify-content-center">
                          <span className="text-secondary">
                            No data available
                          </span>
                        </div>
                      </td>
                    </tr>
                  )}
                  {data?.items?.length > 0 &&
                    data?.items?.map((item, index) => (
                      <tr key={`${item.id}-${index}`}>
                        {columnItemCOA.map((column) => (
                          <td
                            key={column.key}
                            className={`p-2 align-middle ${column.className}`}
                          >
                            {column.key === 'sequence' && index + 1}
                            {column.component && column.component(item)}
                            {!column.component && item[column.key]}
                          </td>
                        ))}
                      </tr>
                    ))}
                </tbody>
              </Table>
            </div>
          </Collapse>
        </Card>

        <Card style={cardFilterStyle}>
          <div className="d-flex flex-row justify-content-between mb-3">
            <h5 className="fw-bold text-uppercase" style={{ color: '#828282' }}>
              STAGING
            </h5>
          </div>
          {data?.stagings?.length > 0 &&
            data?.stagings?.map((stagingArea, index) => (
              <div key={`${stagingArea.id}-${index}`} className="mb-4">
                <Col md={12} className="mb-3">
                  <div className="d-flex justify-content-between">
                    <div className="d-flex gap-2 align-items-center">
                      <History
                        size={14}
                        style={{
                          color: '#828282'
                        }}
                        className="cursor-pointer"
                        role="button"
                        onClick={() => {
                          handleModalTimeline()
                          setPrTimelineId(stagingArea.id)
                        }}
                      />
                      <h6 className="fw-bold text-uppercase mb-0">
                        {stagingArea.staging || ''}
                      </h6>
                    </div>
                    <div className="d-flex justify-content-end item-center gap-2">
                      <h6 className="fw-bold mb-0">
                        {stagingArea?.status === 'unassigned'
                          ? ''
                          : `${data?.driver || ''} • `}
                        <span className="text-uppercase">
                          {stagingArea?.status
                            ? stagingArea?.status?.replaceAll('_', ' ')
                            : '-'}
                        </span>
                      </h6>
                      {stagingArea?.status !== 'unassigned' && (
                        <FileText size={16} color="#828282" />
                      )}
                    </div>
                  </div>
                </Col>
                {stagingArea?.items?.length > 0 && (
                  <Col md={12}>
                    <Table
                      hover
                      responsive
                      className="shadow-sm bg-white"
                      style={{
                        fontSize: '13px',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        marginBottom: 0
                      }}
                    >
                      <thead style={{ backgroundColor: '#f8f9fa' }}>
                        <tr>
                          {columnStagingArea.map((column) => (
                            <th
                              className={`p-2 align-middle ${column.className}`}
                              key={column.key}
                              style={tableHeaderStyle}
                            >
                              {column.label}
                            </th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {stagingArea?.items?.length === 0 && (
                          <tr>
                            <td
                              colSpan={columnStagingArea.length}
                              className="p-3"
                            >
                              <div className="d-flex justify-content-center">
                                <span className="text-secondary">
                                  No data available
                                </span>
                              </div>
                            </td>
                          </tr>
                        )}
                        {stagingArea?.items?.length > 0 &&
                          stagingArea?.items?.map((item, index) => (
                            <tr key={`${item.id}-${index}`}>
                              {columnStagingArea.map((column) => (
                                <td
                                  key={column.key}
                                  className={`p-2 align-middle ${column.className}`}
                                >
                                  {column.key === 'sequence' && index + 1}
                                  {column.component && column.component(item)}
                                  {!column.component && item[column.key]}
                                </td>
                              ))}
                            </tr>
                          ))}
                      </tbody>
                    </Table>
                  </Col>
                )}
              </div>
            ))}
        </Card>

        {['waiting_om', 'done'].includes(data?.status) && !data?.erp_doc && (
          <Row>
            <Col md={12} className="mb-4">
              <div className="d-flex justify-content-end">
                <Button
                  variant="transparent"
                  className="btn-primary-orange fw-bold"
                  onClick={() => handleSubmitAndSendErp()}
                  style={{ height: '37px' }}
                >
                  Submit & Send to ERP
                </Button>
              </div>
            </Col>
          </Row>
        )}

        <Card style={cardFilterStyle}>
          <div className="d-flex flex-row justify-content-between mb-3">
            <h5 className="fw-bold text-uppercase" style={{ color: '#828282' }}>
              Item Receipt Details
            </h5>
          </div>
          {data?.receipt_details?.length > 0 && (
            <Row>
              <Col md={12}>
                <Table
                  hover
                  responsive
                  className="shadow-sm bg-white"
                  style={{
                    fontSize: '13px',
                    borderRadius: '12px',
                    overflow: 'hidden',
                    marginBottom: 0
                  }}
                >
                  <thead style={{ backgroundColor: '#f8f9fa' }}>
                    <tr>
                      {columnItemReceipts.map((column) => (
                        <th
                          className={`p-2 align-middle ${column.className}`}
                          key={column.key}
                          style={tableHeaderStyle}
                        >
                          {column.label}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data?.receipt_details?.length === 0 && (
                      <tr>
                        <td colSpan={columnItemReceipts.length} className="p-3">
                          <div className="d-flex justify-content-center">
                            <span className="text-secondary">
                              No data available
                            </span>
                          </div>
                        </td>
                      </tr>
                    )}
                    {data?.receipt_details?.length > 0 &&
                      data?.receipt_details?.map((item, index) => (
                        <tr key={`${item.id}-${index}`}>
                          {columnItemReceipts.map((column) => (
                            <td
                              key={column.key}
                              className={`p-2 align-middle ${column.className}`}
                            >
                              {column.key === 'sequence' && index + 1}
                              {column.component && column.component(item)}
                              {!column.component && item[column.key]}
                            </td>
                          ))}
                        </tr>
                      ))}
                  </tbody>
                </Table>
              </Col>
            </Row>
          )}
        </Card>

        <Card style={cardFilterStyle}>
          <Row>
            {renderInfoItem('CREATED BY', data?.created_by)}
            {renderInfoItem(
              'CREATED AT',
              convertDateWithTime(data?.created_at)
            )}
            {renderInfoItem('LAST UPDATED BY', data?.updated_by)}
            {renderInfoItem(
              'LAST UPDATED AT',
              convertDateWithTime(data?.updated_at)
            )}
          </Row>
        </Card>

        <ModalPrDetailTimeline
          show={showModalTimeline}
          timelineId={prTimelineId}
          type="mr"
          onHide={handleModalTimeline}
          irId={data?.id}
        />
      </Container>
    </>
  )
}

export default MaterialRejectDetailPage
